export {
  Providers,
  useHideHeader,
  HideHeader,
  useHideFooter,
  HideFooter,
  useSlimConsent,
  useIsSlimConsent,
} from "@/components/providers/Providers";
